import React from 'react';
import type { CSSProperties, ReactElement, ReactNode } from 'react';
import type { Align } from '../domain/types';
import { presentationTableProps } from './table';

export function blockAlignShell(
  align: Align,
  content: ReactNode,
  cellStyle?: CSSProperties,
): ReactElement {
  return (
    <table {...presentationTableProps()}>
      <tbody>
        <tr>
          <td align={align} style={{ ...cellStyle, textAlign: align }}>
            {content}
          </td>
        </tr>
      </tbody>
    </table>
  );
}
